export enum ButtonVariant {
  PRIMARY = 'primary',
  PRIMARY_TRANSPARENT = 'primary-transparent',
  SECONDARY = 'secondary',
  SECONDARY_TRANSPARENT = 'secondary-transparent',
  THEME = 'theme',
}

export enum ButtonSize {
  REGULAR = 'regular',
  TINY = 'tiny',
  ICON = 'icon',
}
